export const alertItemReducerKey = 'AlertItemReducer';

export const selectResultOfAlertType = 'selectResultOfAlertType';
